<template>
    <v-toolbar class="bg-bar" dense flat height="42">
        <v-container
            :class="
                $route.path.includes('sportsbook') &&
                !$route.path.includes('markets')
                    ? 'max-style px-4'
                    : 'px-0'
            "
        >
            <v-row align="center" class="d-flex text-center flex-wrap">
                <v-btn
                    icon
                    height="35"
                    width="35"
                    color="primary"
                    @click="goBack()"
                >
                    <v-icon class="tooltitle">mdi-chevron-left</v-icon>
                </v-btn>
                <v-toolbar-title
                    class="tooltitle white--text font-weight-bold pl-0 body-2 text-capitalize"
                    style="max-width: calc(100% - 140px)"
                >
                    {{ title }}
                </v-toolbar-title>
                <v-spacer></v-spacer>
                <span
                    :class="{
                        'blue-loyalty':
                            loyaltyType && loyaltyType === 'Blue Card',
                        'silver-loyalty':
                            loyaltyType && loyaltyType === 'Silver Card',
                        'gold-loyalty':
                            loyaltyType && loyaltyType === 'Gold Card',
                        'platinum-loyalty':
                            loyaltyType && loyaltyType === 'Platinum Card'
                    }"
                    >{{ loyaltyType }}
                </span>

                <favorite-btn
                    v-if="favoriteBtn"
                    :is-favorite="isFavorite"
                    :market-id="marketId"
                    :game="$route.params.category?.split('-').join(' ')"
                />
                <!-- <a
          v-if="
            title === 'Choose Withdrawal Method' ||
            title === 'Choose Deposit Method'
          "
          href="/referral"
          class="border-referral"
        >
          <v-img
            :src="require('@/assets/images/referandearn.png')"
            alt="Referral"
            max-width="100"
          ></v-img
        ></a> -->
                <v-btn
                    v-if="
                        $auth.loggedIn &&
                        $breakpoint.mdAndUp &&
                        $route.path.includes('sportsbook')
                    "
                    class="align-self-center text-capitalize mr-2 livetv text-white"
                    x-small
                    color="orange"
                    @click="toggleScorecardTvSwitch()"
                >
                    <span>
                        <v-icon size="14">mdi-sync</v-icon>
                    </span>
                    <span v-if="$breakpoint.smAndUp">Switch</span>
                </v-btn>

                <v-btn
                    v-if="
                        showLiveTv &&
                        liveBtn &&
                        $auth.loggedIn &&
                        showTvDepositCount &&
                        checkHideTV() &&
                        tvScorePositionSwitch
                    "
                    x-small
                    color="green"
                    class="text-capitalize"
                    @click="toggleShowLive()"
                >
                    <span v-if="showLive">
                        <v-icon size="14">mdi-close</v-icon>
                        Hide
                    </span>
                    <span v-else>
                        <v-icon size="14"> mdi-play-box-outline</v-icon>
                        Watch
                    </span>
                </v-btn>

                <v-btn
                    v-if="
                        (!$auth.loggedIn || !showLive || $breakpoint.mdAndUp) &&
                        scoreBtn &&
                        !tvScorePositionSwitch
                    "
                    class="align-self-center text-capitalize mr-2 livetv text-white"
                    x-small
                    color="green"
                    @click="toggleShowScore()"
                >
                    <span v-if="showScoreLocal">
                        <v-icon size="14">mdi-eye-off</v-icon>
                    </span>
                    <span v-else>
                        <v-icon size="14">mdi-eye</v-icon>
                    </span>
                    <span v-if="$breakpoint.smAndUp">Score</span>
                </v-btn>

                <!-- for betting pl -->
                <div class="caption-text font-weight-bold pr-2 d-lg-flex tool">
                    <div v-if="totalPL" class="px-lg-2">
                        Total P&amp;L :
                        <span
                            :class="{
                                'success--text ': totalPL > 0,
                                'error--text': totalPL < 0,
                                'white--text ': totalPL == 0
                            }"
                            >{{ totalPL | currencyFormat(2) }}</span
                        >
                    </div>
                    <div v-if="netcommision" class="px-lg-2">
                        Total Net Commission :
                        <span
                            :class="{
                                'success--text ': netcommision > 0,
                                'error--text': netcommision < 0,
                                'white--text ': netcommision == 0
                            }"
                            >{{ netcommision | currencyFormat(2) }}</span
                        >
                    </div>
                </div>
            </v-row>
        </v-container>
    </v-toolbar>
</template>
<script>
import constant from "~/constant"
import FavoriteBtn from "@/components/FavoriteBtn"
export default {
    components: { FavoriteBtn },
    props: {
        title: { type: String, default: "", required: true },
        scoreBtn: { type: Boolean, default: false, required: false },
        showLive: { type: Boolean, default: false, required: false },
        showScore: { type: Boolean, default: false, required: false },
        liveBtn: { type: Boolean, default: false, required: false },
        tvScorePositionSwitch: {
            type: Boolean,
            default: false,
            required: false
        },
        totalPL: { type: [String, Number], default: "", required: false },
        netcommision: { type: [String, Number], default: "", required: false },
        favoriteBtn: { type: Boolean, default: false, required: false },
        isFavorite: { type: Boolean, default: false, required: false },
        marketId: { type: String, default: "", required: false },
        dates: { type: Array, default: () => [], required: false },
        loyaltyType: { type: String, default: "", required: false },
        competitionName: { type: String, default: "", required: false }
    },
    data() {
        return {
            showLiveTv: constant.showLiveTv,
            domainUrl: process.env.THEME_BASIC === "true" ? 1 : 0,
            showScoreLocal: true,
            showLiveLocal: true,
            tvScorecardSwitch: false,
            props: {}
        }
    },
    computed: {
        showTvDepositCount() {
            return process.env.setUp === "fps"
                ? true
                : this.$store.state.wallet.despositCount
        }
    },
    mounted() {
        // setTimeout(() => {
        //     this.showLive = true
        //     this.$listeners.liveBtnClick(this.showLive)
        // }, 500)
        if (process.env.setUp !== "fps") {
            this.totalCountDeposit()
        }
    },
    methods: {
        checkHideTV() {
            if (
                process.env.APP_TITLE !== "SuperWin" &&
                this.$route.params &&
                this.$route.params.category &&
                this.$route.params.category === "Cricket" &&
                this.competitionName &&
                this.competitionName === "Indian Premier League"
            ) {
                return false
            } else return true
        },
        async totalCountDeposit() {
            await this.$store.dispatch("wallet/checkDepositCountForUser")
        },
        goBack() {
            this.$router.go(-1)
            if (this.$route.name === "profit-loss-detail") {
                this.$router.push({
                    path: "/profit-loss",
                    query: { dates: this.dates }
                })
            }
        },
        toggleShowScore() {
            this.showScoreLocal = !this.showScoreLocal
            this.$listeners.scoreBtnClick(this.showScoreLocal)
        },
        toggleShowLive() {
            this.showLiveLocal = !this.showLiveLocal
            this.$listeners.liveBtnClick(this.showLiveLocal)
        },
        toggleScorecardTvSwitch() {
            this.tvScorecardSwitch = !this.tvScorecardSwitch
            this.$listeners.tvPosSwitchBtnClick(this.tvScorecardSwitch)
        }
    }
}
</script>
<style lang="scss">
.px-lg-2 {
    text-align: right;
}
.mob-center {
    .page-title {
        max-width: calc(100% - 170px);
    }
}
.caption-text {
    font-size: 0.75rem;
}
.bg-bar {
    header {
        border-bottom: 1px solid #333;
        border-top: 1px solid #4c4c4c;
        .v-toolbar__title {
            max-width: calc(100vw - 15vw);
            // Ipad Pro
            @media only screen and (max-width: 1024px) {
                max-width: calc(100vw - 20vw);
            }
            // Surface Pro Pro && Nexus 10 Version
            @media only screen and (max-width: 912px) {
                max-width: calc(100vw - 25vw);
            }
            // Ipad Version
            @media only screen and (max-width: 768px) {
                max-width: calc(100vw - 30vw);
            }
            // Nexus 7 Version
            @media only screen and (max-width: 600px) {
                max-width: calc(100vw - 40vw);
            }
            // Iphone 6/7/8 Version
            @media only screen and (max-width: 420px) {
                max-width: calc(100vw - 45vw);
            }
            // Iphone X Version
            @media only screen and (max-width: 375px) {
                max-width: calc(100vw - 50vw);
            }
            //  Galaxy FOld
            @media only screen and (max-width: 360px) {
                max-width: calc(100vw - 55vw);
            }
            @media only screen and (max-width: 300px) {
                max-width: calc(100vw - 75vw);
            }
        }
    }
}
@media only screen and (max-width: 768px) {
    .mob-center {
        button {
            position: absolute;
        }
        .page-title {
            max-width: 100% !important;
            width: 100%;
        }
    }
}
@media only screen and (max-width: 364px) {
    .page-title {
        max-width: 100% !important;
        width: 70% !important;
    }
    .tool {
        position: absolute;
        z-index: 0;
        width: 100%;
        display: grid;
    }
    .tooltitle {
        z-index: 1;
    }
    .pr-2 {
        text-align: right;
        align-items: flex-end;
    }
    .px-lg-2 {
        float: right;
        clear: none;
        align-self: right;
        margin: 0px 0px 0px 35px !important;
    }
}
@media only screen and (max-width: 280px) {
    .caption-text {
        font-size: 10px !important;
    }
}
</style>
